import GalleryTopRightContainer from './galleryTopRightContainer'
export default GalleryTopRightContainer
